import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  sharedTokens: [],
  endpointObject: null,
};

/**
 * @memberOf module:SharedToken
 * @namespace store
 * @description central store for SharedToken module
 */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
